import { ISlotBarLayout, TBarTone } from './slot-bar.interface';

const BAR_TONE_BACKGROUND: Record<TBarTone, string> = {
  empty: 'var(--shikenso-progress-open)',
  error: 'var(--shikenso-progress-failed)',
  hatched: 'repeating-linear-gradient(135deg, var(--shikenso-gray-400) 0 2px, var(--shikenso-gray-base) 2px 5px)',
  info: 'var(--shikenso-info-base)',
  neutral: 'var(--shikenso-gray-400)',
  processing: 'var(--shikenso-info-darker)',
  success: 'var(--shikenso-progress-fulfilled)',
  warning: 'var(--shikenso-progress-partly)',
};

export const SLOT_BAR_GAP = 3;
const SLOT_BAR_AREA = 210;
const SLOT_BAR_MAX_BLOCK = 28;
const SLOT_BAR_MIN_BLOCK = 4;

/** One colour per tone, shared by slot bars, stacked bars and legends so they always match. */
export function getBarToneBackground(tone: TBarTone): string {
  return BAR_TONE_BACKGROUND[tone];
}

/**
 * Block and bar width for bars that share one grid: `capacity` blocks fill the base area, capped at the max width.
 * Below the min width blocks stop shrinking and the bar grows instead.
 */
export function getSlotBarLayout(capacity: number): ISlotBarLayout {
  if (capacity <= 0) {
    return { barWidth: 0, blockWidth: SLOT_BAR_MAX_BLOCK };
  }

  const gaps = SLOT_BAR_GAP * (capacity - 1);
  const blockWidth = Math.min(
    SLOT_BAR_MAX_BLOCK,
    Math.max(SLOT_BAR_MIN_BLOCK, Math.floor((SLOT_BAR_AREA - gaps) / capacity)),
  );

  return { barWidth: capacity * blockWidth + gaps, blockWidth };
}
